import { takeEvery, select, put, cancel, call, delay, fork } from 'redux-saga/effects';
import {
  START_MULTIPLE_MODELING,
} from './actionTypes';
import { verificationWorkFlow, getWorkflowTask, updateWaitingStartMsg } from '../saga';
import {
  updateSimulationReducer,
  updateCurrentSimulationInfo,
  getVerificationLog,
} from '../action';
import { doRockySimulation, getChannelConfig, getVerificationContentPromise } from '../../../../../services/Rocky';
import { API_RES_MESSAGE } from '../../../../../constants/returnCode';
import { checkVerificationStatus, getVerificationWorkFlow } from '../../../../../services/workflow/workflow';
import { VERIFY_SUCCESS } from '../../../../../constants/verificationStatus';
import { MULTIPLE_CHANNEL } from '@/constants/treeConstants';
import dayjs from 'dayjs';
import { judgeIsSIwaveHFSS } from '../../../../../services/Rocky/helper/extractionHelper/data';
import { _saveHybridRegions, getHybridRegionInfo } from '../../project/saga';
import RockySetup from '@/services/Rocky/helper/rockyDatabase';
import projectDesigns from '@/services/helper/projectDesigns';
import { PRE_LAYOUT } from '../../../../../constants/designVendor';
import { autoGetVerificationList } from '../../project/action';
import { extractionOptionsErrorCheck } from '../../../../../services/Rocky/errorCheck/extractionOptions';
import { updateErrorCheckList } from '../../rocky/action';

let workflowTask = getWorkflowTask();

function* _startMultiple(action) {
  let { verificationIds, verificationId } = action;
  if (verificationIds.length === 0) {
    return;
  }

  //cancel prev workflow task
  if (workflowTask) {
    yield cancel(workflowTask);
  }

  let { RockyReducer: { rocky: { infoErrorCheck = [] } } } = yield select();
  yield put(updateErrorCheckList(infoErrorCheck));
  infoErrorCheck = infoErrorCheck.filter(it => it.verificationId !== verificationId && !verificationIds.includes(it.verificationId));
  yield put(updateErrorCheckList(infoErrorCheck));
  let reducer = yield select();

  let simulationReducer = reducer.RockyReducer.simulationReducer;
  let newSimulationReducer = simulationReducer ? JSON.parse(JSON.stringify(simulationReducer)) : {};
  let currentSimInfo = [];
  for (let item of verificationIds) {
    currentSimInfo.push({
      verificationId: item,
      status: 'checking'
    });
    //clean prev simulation info by verificationId
    delete newSimulationReducer[item];
    const time = new Date();
    time.setUTCSeconds(time.getUTCSeconds());
    let waitingTime = dayjs(time.toUTCString()).format('HH:mm:ss');
    newSimulationReducer[item] = {
      startMsg: `==> ${waitingTime} Checking setup...`
    }
  }
  // yield put(updateErrorCheckList([]));
  yield put(updateSimulationReducer(newSimulationReducer));

  const { RockyReducer: { project: { currentProjectId, projectList, projectVersion }, rockyMultiple: { channelId, list } } } = yield select();
  const vendor = projectDesigns.getAvailableDesignsVendor(currentProjectId);
  if (vendor !== PRE_LAYOUT) {
    const configRes = yield call(getChannelConfig, channelId);
    const isHybrid = judgeIsSIwaveHFSS(configRes.config.extraction);
    if (isHybrid) {
      const channel = list.find(item => item.id === verificationId);
      const info = yield call(getHybridRegionInfo, { verificationId }) || {};
      const hybridRegions = info.hybrid_regions || [];
      const hybridLines = info.hybrid_lines || [];
      const errorList = yield call(errorCheck, { verificationId, currentSimInfo, designId: channel.id, vendor, extraction: configRes.config.extraction, hybridRegions });
      if (errorList.length > 0) {
        return;
      }
      let Port_setups = [], Signals = [], ReferenceNets = [], Ports_generate_setup_list = [];
      const currentProject = projectList.find(item => item.id === currentProjectId);
      let rockyType = currentProject ? currentProject.type : '';
      for (const verification of channel.runInfo.comesFrom || []) {
        const verificationId = verification.verificationId;
        try {
          const res = yield call(getVerificationContentPromise, verificationId);
          const info = RockySetup.mergeInterfacesInfo(res.interfaces, res.name, rockyType, projectVersion);
          // console.log(info);
          Port_setups.push(...info.Port_setups);
          Signals.push(...info.Signals);
          ReferenceNets.push(...info.ReferenceNets);
          Ports_generate_setup_list.push(...info.Ports_generate_setup_list);
        } catch (error) {
          console.log(error);
        }
      }

      yield call(_saveHybridRegions, {
        verificationId,
        saveHfssZones: true,
        channelId: channelId,
        designId: channel.designId,
        hybridRegions,
        hybridLines,
        channelInfo: {
          extraction: configRes.config.extraction.extractionConfig,
          signals: Signals,
          port_setups: Port_setups,
          ports_generate_setup_list: Ports_generate_setup_list,
          referenceNets: Array.from(new Set(ReferenceNets))
        }
      })
    }
  }

  reducer = yield select();
  simulationReducer = reducer.RockyReducer.simulationReducer;
  let waitingTask = null;
  try {
    waitingTask = yield fork(updateWaitingStartMsg, { verificationIds, _simulation: simulationReducer })
    const channels = [{ verificationIds: [...verificationIds], options: ["modeling", "simulation"], pdnId: null }];
    yield call(doRockySimulation, channels);
    yield cancel(waitingTask);
  } catch (error) {
    if (waitingTask) { yield cancel(waitingTask); }
    yield* verificationIds.map(function* (item) {
      simulationReducer[item] = {};
      let msg = ""
      if (error && error.code === API_RES_MESSAGE) {
        msg = `==> ${error.msg}`;
        // get log
        yield put(getVerificationLog(item));
        simulationReducer[item].simulationMsg = msg;
      } else {
        msg = `==> ${error}`;
        simulationReducer[item].endMsg = msg;
      }
    })
    yield put(updateSimulationReducer(simulationReducer));
    yield delay(1000);
    if (!verificationId) { return }
    yield put(updateCurrentSimulationInfo({ verificationId, item: "startMsg", info: null }));
    yield put(updateCurrentSimulationInfo({ verificationId, item: "progress", info: -1 }));

    const promise = yield call(checkVerificationStatus, verificationId);
    let resultExist = false;

    if (promise && promise.status) {
      if (promise.status === VERIFY_SUCCESS) {
        resultExist = true;
      }
    };
    yield put(updateCurrentSimulationInfo({ currentVerificationId: verificationId, item: "resultExist", info: resultExist }));
    return;
  }

  // fake progress
  // id: workflowId
  // yield put(autoGetVerificationList({ projectId: currentProjectId, channelId: currentChannelId }));
  if (!verificationId) { return }
  const verificationStatus = yield call(getVerificationWorkFlow, verificationId);
  // update status
  if (verificationStatus && verificationStatus.length > 0) {
    if (workflowTask) {
      yield cancel(workflowTask);
    };
    workflowTask = yield fork(verificationWorkFlow, { verificationId, verificationWork: verificationStatus, simulationType: MULTIPLE_CHANNEL });
    return;
  };
}

function* errorCheck(action) {
  let { verificationId, currentSimInfo, designId, vendor, extraction, hybridRegions } = action;
  if (vendor === PRE_LAYOUT || !designId) {
    return [];
  }
  const { RockyReducer: {
    project: { currentProjectId, currentChannelId },
    rocky: { infoErrorCheck = [] },
    simulationReducer = {}
  } } = yield select();
  const errors = extractionOptionsErrorCheck({ extractionConfig: extraction.extractionConfig, hybridRegions });
  if (errors.length > 0) {
    simulationReducer[verificationId] = {};
    const errorIndex = infoErrorCheck.findIndex(it => it.verificationId === verificationId);
    if (errorIndex > -1) {
      infoErrorCheck[errorIndex].extractionError = errors;
    } else {
      infoErrorCheck.push({ verificationId, extractionError: errors });
    }

    const currIndex = currentSimInfo.findIndex(it => it.verificationId === verificationId);
    if (currIndex > -1) {
      currentSimInfo[currIndex].status = 'error';
    }
  }

  if (errors.length > 0) {
    //update tree verification status
    yield put(autoGetVerificationList({ projectId: currentProjectId, channelId: currentChannelId, currentSimInfo }));
    //update simulation reducer
    yield put(updateSimulationReducer(simulationReducer));
    yield put(updateErrorCheckList(infoErrorCheck));
  }

  return errors;
}

function* multipleSaga() {
  yield takeEvery(START_MULTIPLE_MODELING, _startMultiple);
}

export default multipleSaga;